import EditComponent from "~/components/pages/supervisor/worklist/edit";

export default function EditPage() {
  return (
    <div>
      <EditComponent />
    </div>
  );
}
